import { createContext, useContext, useMemo, useState } from 'react';

const FormDebugContext = createContext({});

export function FormDebugProvider({
  children,
  debug = false,
  debugStepsOnly = false,
}) {
  const [debugStatements, setDebugStatements] = useState([]);
  const [debugSteps, setDebugSteps] = useState([]);
  const isProd = process.env.NODE_ENV === 'production';

  const getTime = () => {
    const now = new Date();
    const time = now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return time;
  };

  const add = (type, message) => {
    if (!isProd) {
      if (!debugStepsOnly) {
        setDebugStatements(prev => [...prev, { [type]: message }]);
      }
    }
  };

  const addStep = message => {
    if (!isProd) {
      const newMessage = `${message} ${getTime()}`;
      setDebugSteps(prev => [...prev, newMessage]);
    }
  };

  const get = () => {
    if (!isProd) {
      return debugStatements;
    }
    return null;
  };

  const log = () => {
    if (debug && !isProd) {
      if (!debugStepsOnly) {
        // eslint-disable-next-line no-console
        console.log('Debug', Object.assign({}, ...debugStatements));
      }
      // eslint-disable-next-line no-console
      console.log('Steps', debugSteps);
    }
  };

  const value = useMemo(
    () => ({
      debug,
      get,
      add,
      log,
      addStep,
      debugStepsOnly,
    }),
    [debug, get, add, log, addStep, debugStepsOnly],
  );

  return (
    <FormDebugContext.Provider value={value}>
      {children}
    </FormDebugContext.Provider>
  );
}

export const useFormDebug = () => {
  return useContext(FormDebugContext);
};
